import { useState, useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';

import { useCategoryLinks, CategoryLink } from 'shop/hooks/categories/use-category-links';

type UseShopDropdownReturn = {
  showShopMenu: boolean;
  categoryLinks: CategoryLink[];
  isCategoryLinksLoading: boolean;
  toggleShopMenu: () => void;
};

export function useShopDropdown(): UseShopDropdownReturn {
  const router = useRouter();
  const [showShopMenu, setShowShopMenu] = useState(false);
  const { categoryLinks, loading: isCategoryLinksLoading } = useCategoryLinks();

  const toggleShopMenu = useCallback((): void => {
    setShowShopMenu(!showShopMenu);
  }, [showShopMenu]);

  useEffect(() => {
    const handleRouteChange = (): void => {
      if (showShopMenu) {
        toggleShopMenu();
      }
    };

    router.events.on(`routeChangeStart`, handleRouteChange);
    return () => {
      router.events.off(`routeChangeStart`, handleRouteChange);
    };
  }, [router, showShopMenu, toggleShopMenu]);

  return {
    showShopMenu,
    categoryLinks,
    isCategoryLinksLoading,
    toggleShopMenu,
  };
}
